<template>
    <div class="center-page">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="接机需求" name="1"></el-tab-pane>
            <el-tab-pane label="送机需求" name="2"></el-tab-pane>
        </el-tabs>
        <div class="list-content" v-loading="loading">
            <div class="list-item" v-for="(item,index) in list" :key="index">
                <div class="list-item-top">
                    <div>发布于：{{item.created_at}}</div>
                    <span v-if="item.status==0" class="f-14">等待接单中</span>
                    <span v-if="item.status==1" class="f-14">导游已报价</span>
                    <span v-if="item.status==2" class="f-14 color-red">已接单</span>
                </div>
                <div class="list-item-content">
                    <el-form label-width="120px" label-position="right">
                        <el-col :span="12">
                            <el-form-item style="margin-bottom: 0;" label="机场/目的地：">{{`${item.airport}-${item.address}`}}</el-form-item>
                            <el-form-item style="margin-bottom: 0;" label="出发时间：">{{item.time}}</el-form-item>
                            <el-form-item style="margin-bottom: 0;" label="人数：">{{item.people}}人</el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item style="margin-bottom: 0;" label="联系人：">{{item.contact}}</el-form-item>
                            <el-form-item style="margin-bottom: 0;" label="手机号：">{{item.telphone}}</el-form-item>
                            <el-form-item style="margin-bottom: 0;" label="行李：">{{item.bags}}件</el-form-item>
                            <el-form-item style="margin-bottom: 0;" label="">
                                <el-button v-if="item.is_cancel===0" class="mr-20 ml-a" type="primary" @click="cancleNeed(item)" size="mini">取消需求</el-button>
                                <el-button v-if="item.status>0" class="mr-20 ml-a" type="primary" @click="toDetail" size="mini">查看详情</el-button>
                            </el-form-item>
                        </el-col>
                    </el-form>

                </div>
            </div>
            <el-pagination
                    background
                    :page-size="5"
                    hide-on-single-page
                    @current-change="pageChange"
                    :current-page="page"
                    layout="prev, pager, next"
                    :total="total">
            </el-pagination>
            <el-alert v-if="list.length<=0" title="暂无发布需求~" center :closable="false" type="warning" show-icon></el-alert>
        </div>
    </div>
</template>

<script>
    import {delToast} from '@/utlis/decorators'
    export default {
        name: "myNeeder",
        data() {
            return {
                loading: false,
                activeName: '1',
                list: [],
                total: 0,
                page: 1
            }
        },
        created() {
            this.page = 1;
            this.planeIndex();
        },
        methods: {
            handleClick(){
                this.page = 1;
                this.planeIndex();
            },
            pageChange(e){
                this.page = e;
                this.planeIndex();
            },
            async planeIndex() {
                this.loading = true;
                let [e, data] = await this.$api.planeIndexApi({
                    type: this.activeName,
                    page: this.page
                })
                this.loading = false;
                this.list = data.result.data;
                this.total = data.result.total;
            },
            toDetail(){

            },
            @delToast('是否取消该需求？')
            async cancleNeed(item){
                let [e, data] = await this.$api.userBackMoneyApi({
                    out_trado_no: item.out_trado_no
                })
                if(data.code === 200){
                    this.planeIndex();
                }else {
                    this.$message.warning(data.error)
                }
            }
        },
    }
</script>

<style scoped lang="less">
    .list-content{
        padding: 20px 0;
        box-sizing: border-box;
        width: 100%;
        .list-item{
            width: 100%;
            margin-bottom: 20px;
            box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
            border-radius: 8px;
            overflow: hidden;
        }
        .list-item-top{
            width: 100%;
            height: 44px;
            background-color: #f5f5f5;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 20px;
            box-sizing: border-box;
        }
        .list-item-content{
            padding: 10px 0;
            overflow: hidden;
            width: 100%;
            box-sizing: border-box;
        }
    }
</style>
